/* Màn 1 — Dashboard Telesales: 3 góc nhìn Quản lý vận hành · Nhân viên Telesales · Tư vấn cơ sở */
import React from 'react';
import { StoreCtx, useStore } from './components/Store';
import Layout from '../../Layout'
import { SoftBar } from './components/SoftBar';
import TeleDrawer from './components/TeleDrawer';
import { Helmet } from 'react-helmet-async';
import TelesalesDashboard from './dashboard';

const TeleDashboard: React.FC = () => {
  const store = useStore();
  return (
    <StoreCtx.Provider value={store}>
      <Layout>
        <Helmet>
          <title>Dashboard Telesales | Khothi</title>
        </Helmet>
        <div className="relative flex min-h-0 flex-1">
          <div className="relative min-w-0 flex-1">
            <TelesalesDashboard />
            <SoftBar />
          </div>
          <TeleDrawer />
        </div>
      </Layout>
    </StoreCtx.Provider>
  );
}

export default TeleDashboard;
